/**
 * Mobile gallery thumbnail switching
 * Changes the main image when a thumbnail is clicked
 */

function changeImage(thumbnail) {
  const mainImage = document.getElementById('main-image');
  if (mainImage && thumbnail.dataset.fullSrc) {
    mainImage.src = thumbnail.dataset.fullSrc;

    // Update active state on thumbnails
    document.querySelectorAll('.thumbnail').forEach(thumb => {
      thumb.classList.remove('active');
    });
    thumbnail.classList.add('active');
  }
}

// Also support clicking thumbnails without inline onclick
document.addEventListener('DOMContentLoaded', function() {
  const thumbnails = document.querySelectorAll('.thumbnail');
  thumbnails.forEach(thumb => {
    thumb.addEventListener('click', function() {
      changeImage(this);
    });
  });
});
